import Connector from '../../agent';
import types from './types';
import { takeQuery } from 'react-lib/dist/agent-es';

const LmsCourses = {
  getRequiredLmsCourses: () => Connector.api.get('/lmsCourses/getRequired')
};

const lmsCoursesSagas = [
  takeQuery(types.GET_REQUIRED_LMS_COURSES, LmsCourses.getRequiredLmsCourses)
];

export default lmsCoursesSagas;
